import React from 'react';
import cn from 'classnames';
import compact from 'lodash/compact';
import { Button, Typography } from 'seagull';
import { useStore } from "../../../contexts";
import { selectors } from "../../../store/state-selectors";
import { useSwitchBusiness } from "../../../hooks/useSwitchBusiness";
import { routes } from "../../../constants";
import { HelpMenu } from "../HelpMenu";
import { InAppNotificationsButton } from "../InAppNotificationsButton";
import UserMenu from "../UserMenu/UserMenu";
import { BusinessSwitcher } from "./components/BusinessSwitcher/BusinessSwitcher";
import { CreateAVendorAccount } from "./components/CreateAVendorAccount";
import styles from "./TopBar.module.scss";
export function TopBar(props) {
  var _userInfo$worksAt;
  const {
    'data-testid': testId
  } = props;
  const userInfo = useStore(state => state.userInfo);
  const userId = useStore(selectors.user.id);
  const isVendor = useStore(selectors.user.isVendor);
  const businessName = useStore(selectors.user.businessName);
  const isAccountant = useStore(selectors.user.isAccountant);
  const isAnchorAdmin = useStore(selectors.user.isAnchorAdmin);
  const {
    switchBusiness,
    getPrevBusinessId
  } = useSwitchBusiness();
  const workspaces = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.workspaces) || [];
  const hasAVendorAccount = workspaces.some(workspace => workspace.features.accountsReceivable);
  const shouldShowCreateVendorAccount = !isVendor && !hasAVendorAccount;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": testId,
    className: cn(styles.root, {
      [styles.accountant]: isAccountant,
      [styles.anchorAdmin]: isAnchorAdmin
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.start
  }, isAccountant && /*#__PURE__*/React.createElement("div", {
    className: styles.accountantSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph2"
  }, "You are now logged in to", ' ', /*#__PURE__*/React.createElement(Typography, {
    as: "span",
    variant: "paragraph2",
    weight: "normal"
  }, businessName)), /*#__PURE__*/React.createElement(Button, {
    className: styles.backBtn,
    size: "small",
    skin: "primaryOutline",
    "data-testid": "".concat(testId, "-back-to-my-business"),
    onClick: () => switchBusiness(getPrevBusinessId(), {
      newRoute: routes.agreementsDashboard
    })
  }, "Back to my business")), isAnchorAdmin && (userInfo === null || userInfo === void 0 ? void 0 : userInfo.worksAt) && /*#__PURE__*/React.createElement(AnchorAdmin, {
    companyName: userInfo === null || userInfo === void 0 || (_userInfo$worksAt = userInfo.worksAt) === null || _userInfo$worksAt === void 0 ? void 0 : _userInfo$worksAt.name
  }), !isAccountant && !isAnchorAdmin && userInfo && /*#__PURE__*/React.createElement(BusinessSwitcher, {
    userInfo: userInfo
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.end,
    "data-testid": "".concat(testId, "-end-container-").concat(isVendor ? 'vendor' : 'client')
  }, compact([{
    id: 'marketing-content',
    value: null
  }, shouldShowCreateVendorAccount && {
    id: 'create-vendor-account',
    value: /*#__PURE__*/React.createElement(CreateAVendorAccount, null)
  }, {
    id: 'help',
    value: userId && /*#__PURE__*/React.createElement(HelpMenu, {
      userId: userId
    })
  }, isVendor && {
    id: 'in-app-notifications',
    value: /*#__PURE__*/React.createElement(InAppNotificationsButton, null)
  }, userId && {
    id: 'user',
    value: /*#__PURE__*/React.createElement(UserMenu, {
      userInfo: userInfo
    })
  }]).map(_ref => {
    let {
      id,
      value
    } = _ref;
    return /*#__PURE__*/React.createElement("div", {
      key: id,
      "data-testid": "".concat(testId, "-").concat(id),
      className: styles.endItem
    }, value);
  })));
}
const AnchorAdmin = _ref2 => {
  let {
    companyName
  } = _ref2;
  return /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph2",
    breakWords: true
  }, "You are now logged as an Anchor Admin to", ' ', /*#__PURE__*/React.createElement(Typography, {
    as: "span",
    weight: "bold"
  }, companyName));
};